import React, { Component, useRef, useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { FaBullhorn } from "react-icons/fa";

import "../styles/components/_header.scss";
import "../styles/components/_outdated.scss";
import { fetchDailyMessages } from "../actions/ams";

import { withRouter } from "../helpers/withRouter";
import { getMessages, getMessagesLoaded } from "../reducers";
import Navigation from "./Navigation";

class Header extends Component {
  static propTypes = {
    navlinks: PropTypes.bool,
  };

  static defaultProps = {
    navlinks: false,
  };

  componentDidMount() {
    this.fetchDailyMessages();
    this.refreshIntervalId = setInterval(
      this.props.fetchDailyMessages,
      1000 * 60 * 5
    );
  }

  componentDidUpdate(prevProps) {
    if (
      this?.props?.location?.pathname !== prevProps?.location?.pathname ||
      this.props?.location?.search !== prevProps?.location?.search
    ) {
      const outdatedUI = document.getElementById("outdated");
      outdatedUI.style.opacity = 0;
      window.onload();
    }
  }

  componentWillUnmount() {
    clearInterval(this.refreshIntervalId);
  }

  refreshIntervalId = null;

  fetchDailyMessages() {
    const { messagesLoaded, fetchDailyMessages } = this.props;
    if (!messagesLoaded) {
      fetchDailyMessages();
    }
  }

  render() {
    const { messagesLoaded, messages } = this.props;

    return (
      <React.Fragment>
        <div id="outdated" />
        {messagesLoaded && messages.length > 0 && (
          <MessageBar message={messages[0]} />
        )}
        <header className="header">
          <Navigation navlinks={this.props.navlinks} />
        </header>
      </React.Fragment>
    );
  }
}

const MessageBar = ({ message }) => {
  const [hasOverflow, setHasOverflow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScolled] = useState(false);

  const motd = useRef(null);

  useEffect(() => {
    setHasOverflow(motd.current.offsetHeight < motd.current.scrollHeight);
  }, []);

  const handleClick = () => setIsOpen(!isOpen);

  const handleScroll = () => {
    setScolled(
      motd.current.scrollTop >
        motd.current.scrollHeight - motd.current.offsetHeight - 6
    );
  };

  if (message.message === "" || message.message === "<p></p>") {
    return null;
  }

  return (
    <div className="alert-bar" onClick={handleClick}>
      <div className="alert-bar__wrap">
        <div className="alert-bar__icon">
          <FaBullhorn color="white" />
        </div>
        <div
          className={`alert-bar__message ${
            hasOverflow && "alert-bar__message--overflow"
          } ${isOpen && "alert-bar__message--open"} ${
            scrolled && "alert-bar__message--scrolled"
          }`}
        >
          <div
            ref={motd}
            onScroll={handleScroll}
            dangerouslySetInnerHTML={{
              __html: `<p>${message.message}</p>`,
            }}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    messages: getMessages(state),
    messagesLoaded: getMessagesLoaded(state),
  };
};

export default connect(mapStateToProps, {
  fetchDailyMessages,
})(withRouter(Header));
